import type { Product, RecurrencePlan } from '@entities/product/api/product.contract'

export function plansToDeactivate(
  nextPlans: readonly RecurrencePlan[],
  previousPlans: readonly RecurrencePlan[],
): RecurrencePlan[] {
  const nextPlanIds = new Set(nextPlans.map((plan) => plan.id))
  return previousPlans.filter((previousPlan) => !nextPlanIds.has(previousPlan.id))
}

export function projectPrimaryPricing(product: Product): Product {
  const primaryOfferId =
    product.links.primaryOfferId || product.links.offers[0]?.offerId || product.offers[0]?.id || ''
  const primaryOffer =
    product.offers.find((offer) => offer.id === primaryOfferId) ?? product.offers[0]

  return {
    ...product,
    offers: primaryOffer ? [primaryOffer] : [],
    recurrencePlans: product.recurrencePlans.slice(0, 1),
    links: {
      ...product.links,
      primaryOfferId: primaryOffer?.id ?? '',
      offers: primaryOffer
        ? product.links.offers.filter((offer) => offer.offerId === primaryOffer.id)
        : [],
    },
  }
}
